module.exports = __webpack_public_path__ + "static/media/Basal_8000.9eddbb39.jpg";